module.exports = __webpack_public_path__ + "img/allNews.619ffc58.svg";